<template>
	<router-view v-slot="{ Component }">
		<transition :name="transitionName">
			<component :is="Component" :key="$route.fullPath" />
		</transition>
	</router-view>
	<BottomMenuBar v-show="botMenuList.includes(currentPage)"></BottomMenuBar>
	<TeleportModal v-if="store.state.modal.SafetyCheckChecklistModal">
		<SafetyCheckChecklistModal />
	</TeleportModal>
	<!-- <ToTop /> -->
	<!-- <Header /> -->
	<!-- <Footer /> -->
</template>

<script setup>
	// import ToTop from '@/components/ToTop'
	// import Header from "@/components/Header";
	// import Footer from "@/components/Footer";
	import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
	import { useRoute } from 'vue-router';
	import { useStore } from 'vuex';
	import BottomMenuBar from './components/BottomMenuBar.vue';
	import TeleportModal from './components/TeleportModal.vue';
	import SafetyCheckChecklistModal from './components/SafetyCheckChecklistModal.vue';
	import {
		getPushToken,
		getPushPermissionYn,
		requestPermissionNotification,
		getOsEnvironment,
	} from './utils/nativeRequestFunctions';
	import { useUpdatePushTokenApi } from './api/nativeInterface';
	import useAxios from './compositions/useAxios';
	import { getUserInfo } from './api/user';

	const { fetchData } = useAxios();

	let transitionName = ref('');
	let lastHistoryPosition = ref(window.history.state.position);
	const botMenuList = ['Home', 'MyPage', 'Inventory', 'Calendar'];
	const route = useRoute();
	const store = useStore();

	const currentPage = computed(() => {
		return route.name;
	});
	const noTransitionPage = [...botMenuList];

	watch(
		() => route.name,
		(to, from) => {
			const currentHistoryPosition = window.history.state.position;
			transitionName.value = 'none';
			if (store.state.header.isBack) {
				// 뒤로 가기 버튼 눌렸을 시 왼쪽에서 덮임
				transitionName.value = 'slide-left';
				store.commit('header/inactivateBack');
			} else if (noTransitionPage.includes(to) && noTransitionPage.includes(from)) {
				// 바텀메뉴 -> 바텀메뉴 간 이동 시 효과없음
				transitionName.value = 'none';
			} else {
				if (from === undefined) return; // 새로고침시
				if (currentHistoryPosition < lastHistoryPosition.value) return; // 헤더에 뒤로가기 버튼을 누르지 않고 스와이프로 뒤로가기시
				transitionName.value = 'slide-right';
			}
			lastHistoryPosition.value = currentHistoryPosition;
		},
	);

	watch(
		() => [store.state.user.userInfo.user.showCheckPopupYn, store.state.user.isLogin],
		([showCheckPopupYn, isLogin]) => {
			if (isLogin && showCheckPopupYn === 'Y') {
				store.commit('modal/openModal', 'SafetyCheckChecklistModal');
			}
		},
		{ immediate: true },
	);

	onBeforeMount(() => {
		// native -> js interface
		window.nativeInterface = {
			// 푸쉬 fcm token 요청 함수
			nativeResultGetPushToken: async (event) => {
				// alert(`푸쉬 fcm token 요청 함수: ${JSON.stringify(event)} `);
				const agent = navigator.userAgent.toLowerCase();
				const deviceType = agent.includes('android')
					? 'android'
					: agent.includes('iphone') || agent.includes('ipad') || agent.includes('ipod')
					? 'ios'
					: 'other';
				const employeeNumber = store.state.user.userInfo.user.employee_number;
				const userId = store.state.user.userInfo.user.id;

				if (employeeNumber && userId) {
					await useUpdatePushTokenApi({
						fcm_token: event.token ?? '',
						device_type: deviceType,
						employee_number: employeeNumber,
						id: userId,
					}).catch((err) => {
						console.error(err); // token 저장 API 호출
					});

					// alert(`토큰: ${event.token}`);
				}
			},
			// 푸쉬 권한 여부 받는 함수
			nativeResultCheckPermissionNotification: (event) => {
				// alert('푸쉬 권한 여부 받는 함수', JSON.stringify(event.enable));
				if (!event.enable) {
					requestPermissionNotification(); // 푸시 권한 요청
				}
			},
		};
	});

	onMounted(async () => {
		// axios.js 의 인터셉터의 상태코드(만료여부) 확인하기 위한 api (실제 api역할과는 상관없음)

		getPushPermissionYn();
		if (getOsEnvironment() === 'AOS_APP') {
			const userInfoResponse = await getUserInfo();
			store.commit('user/setUserInfo', userInfoResponse.user || userInfoResponse);
		}

		// 자동로그인의 경우
		if (store.state.token.access_token) {
			getPushToken(); // push token(fcm 토큰) 요청
		} else {
			store.commit('user/setLogout');
		}
		setTimeout(() => {
			// getPushPermissionYn(); // 푸시 권한 여부 체크
		}, 1000);
	});
</script>

<style>
	@import url('./assets/css/reset.css');
	@import url('./assets/css/common.css');
	@import url('./assets/css/layout.css');
</style>
